import { createAppKit } from '@reown/appkit/react'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'

// Project IDを環境変数から取得
const projectId = import.meta.env.VITE_PROJECT_ID
const infuraApiKey = import.meta.env.VITE_APP_INFURA_API_KEY

if (!projectId) {
  console.warn('VITE_PROJECT_ID is not set in .env.local')
}

if (!infuraApiKey) {
  console.warn('VITE_APP_INFURA_API_KEY is not set in .env.local')
}

// Infura RPC URL（フォールバック付き）
const infuraRpcUrl = infuraApiKey 
  ? `https://mainnet.infura.io/v3/${infuraApiKey}`
  : 'https://eth.llamarpc.com'

// メタデータ設定
const metadata = {
  name: 'BŌSŌ TOKYO',
  description: 'BŌSŌ TOKYO, an identity defining brand in the Metaverse',
  url: 'https://www.bosotokyo.com',
  icons: ['https://www.bosotokyo.com/logo192.png']
}

// Ethereum Mainnetの定義（Chain ID: 1）
export const mainnet = {
  id: 1,
  name: 'Ethereum',
  network: 'mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Ethereum',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: {
      http: [infuraRpcUrl],
    },
    public: {
      http: [infuraRpcUrl],
    },
  },
  blockExplorers: {
    default: {
      name: 'Etherscan',
      url: 'https://etherscan.io',
    },
  },
}

export const networks = [mainnet]

// EthersAdapterを作成
const ethersAdapter = new EthersAdapter({
  networks,
  projectId,
})

// AppKitを作成
createAppKit({
  adapters: [ethersAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true // Optional - defaults to your Cloud configuration
  }
})

